var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entityExist())?_c('span',{class:_vm.entityStatus(),attrs:{"title":_vm.entitySubtitle()}},[_vm._v(_vm._s(_vm.entity_name))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }